module.exports = __webpack_public_path__ + "fonts/7149c7c.woff2";